"use client";

import { Clock } from "iconsax-reactjs";
import { useTranslations } from "next-intl";
import { useDateFormatter } from "@/lib/i18n/date";
import { cn } from "@/lib/utils";

interface BlogMetaProps {
  /** Resolved byline (FE constant; see `@/lib/blog/labels` AUTHOR_LABEL). */
  author: string;
  publishedAt: string | null;
  className?: string;
}

/**
 * Detail-page byline + published lines. RTL: default alignment is already the
 * reading-start (right) — no alignment class needed. Share moved to
 * `BlogShareRow`; views to the detail header chip row.
 */
export const BlogMeta: React.FC<BlogMetaProps> = ({
  author,
  publishedAt,
  className,
}) => {
  const t = useTranslations("blog");
  const df = useDateFormatter();
  return (
    <div className={cn("space-y-2 text-sm", className)}>
      <p>
        <span className="text-text-secondary">{t("meta.by")}</span>{" "}
        <span className="font-medium text-text-primary">{author}</span>
      </p>
      {publishedAt && (
        <p className="flex items-center gap-1.5 text-text-secondary">
          <Clock size={16} aria-hidden="true" />
          <span>{t("meta.publishedAt")}</span>
          <span className="text-text-primary">
            {df.dateTimeMarker(publishedAt)}
          </span>
        </p>
      )}
    </div>
  );
};
